import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploaderModel } from '../../../../shared/components/file-uploader/file-uploader.model';
import {Component, ViewChild, Injector, Input} from '@angular/core';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import {PieceReclamationPrealable} from '../../../../entities/piece-jointe';
import { FileUploaderComponent } from '../../../../shared/components/file-uploader/file-uploader.component';
import {DraftDepotRequeteService} from '../../../draft-depot-requete.service';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {DragulaService} from 'ng2-dragula';

@Component({
    selector: 'jhi-reclamation-prealable',
    templateUrl: './reclamation-prealable.component.html',
    styleUrls: ['./reclamation-prealable.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ReclamationPrealableComponent,
            multi: true
        }
    ]
})
export class ReclamationPrealableComponent extends BaseControlValueAccessor {

    @ViewChild('reclamationPrealablesAdder')
    pieceAdder: FileUploaderComponent;

    @Input()
    maxReclamationPrealablesForMerge: number;

    @Input()
    draftRequeteId: number;

    @Input()
    required: boolean;

    reclamationPrealables: PieceReclamationPrealable[] = [];

    // --- drag n drop keyboard accessible
    public selectedItem = null;

    constructor(injector: Injector, private draftDepotRequeteService: DraftDepotRequeteService,
                private liveAnnouncer: LiveAnnouncer,
                private dragulaService: DragulaService) {
        super(injector);

        this.dragulaService.drop.subscribe(() => {
            this.liveAnnouncer.announce('élément relaché');
        });

        this.dragulaService.drag.subscribe(() => {
            this.liveAnnouncer.announce('élément selectionné ');
        });
    }

    protected modelValueChanged(value: any): void {
        this.reclamationPrealables = value;
    }

    markAsUntouched() {
        if (this.pieceAdder) {
            this.pieceAdder.markAsUntouched();
        }
    }

    onReclamationPrealableAdd(file: FileUploaderModel) {
        if (file) {
            this.reclamationPrealables.push(new PieceReclamationPrealable(file));
            this.pieceAdder.deleteFile();
        }
        this.onChange(this.reclamationPrealables);
    }

    onReclamationPrealableDelete(index: number, file: FileUploaderModel) {
        if (!file) {
            this.reclamationPrealables.splice(index, 1);
        }
        this.onChange(this.reclamationPrealables);
    }

    moveUp(index: number) {
        if (index > 0) {
            this.swapReclamationPrealables(index - 1, index);
        }
    }

    moveDown(index: number) {
        if (index < this.reclamationPrealables.length - 1) {
            this.swapReclamationPrealables(index + 1, index);
        }
    }

    trackByFileApiId(_index: number, item: PieceReclamationPrealable) {
        return item.fileModel.fileApiId;
    }

    private swapReclamationPrealables(piece1Index: number, piece2Index: number) {
        const piece1 = this.reclamationPrealables[piece1Index];
        const piece2 = this.reclamationPrealables[piece2Index];
        this.reclamationPrealables[piece2Index] = piece1;
        this.reclamationPrealables[piece1Index] = piece2;
    }

    get uploadUrl(): string {
        return this.draftDepotRequeteService.buildUploadUrl();
    }

    // --- drag n drop keyboard accessible
    onMoveup(data: any) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    }

    onMovedown(data: any) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    }

    onSelect(data: any) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    }

    onEscape(data: any) {
        console.log('onEscape', data);
        this.selectedItem = null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requete/reclamation-prealable/reclamation-prealable.component.ts